import type { ErrorEvent } from "@sentry/nextjs";

// Shared Sentry init options for server / edge / client.
//
// PII posture (load-bearing): the Aluume guardrails forbid customer PII leaving
// controlled systems, and this Sentry org is in the US region. So we send the
// MINIMUM — errors only, no PII — and scrub every event before it leaves.
//
// Activation is gated: Sentry is enabled ONLY when a DSN is present AND we're in
// production. The shared dev server (NODE_ENV=development, no DSN) therefore runs
// Sentry as a complete no-op — it can't be destabilised by this.

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

/** Strip request metadata and user identity that can carry emails/names/tokens. */
function scrub(event: ErrorEvent): ErrorEvent {
  if (event.request) {
    delete event.request.cookies;
    delete event.request.headers;
    delete event.request.data;
    delete event.request.query_string;
    if (typeof event.request.url === "string") event.request.url = event.request.url.split("?")[0];
  }
  delete event.user;
  return event;
}

export const sentryShared = {
  dsn,
  enabled: !!dsn && process.env.NODE_ENV === "production",
  // Errors only — no performance traces (less data, less PII surface, less quota).
  tracesSampleRate: 0,
  // Never auto-attach IPs / cookies / headers.
  sendDefaultPii: false,
  beforeSend: (event: ErrorEvent): ErrorEvent => scrub(event),
};
